export enum ConfirmationDialogType {
  WARNING = 'warning',
  ERROR = 'error',
  SUCCESS = 'success'
}
